import {RouterModule, Routes} from '@angular/router';
import {EditComponent} from '../edit/edit.component';
import {AuthGuard} from '../core';
import {EditableDealResolver} from '../edit/editable-deal-resolver.service';
import {NgModule} from '@angular/core';
import {PasswordResetComponent} from './password-reset.component';

const routes: Routes = [
    {
        path: '',
        component: PasswordResetComponent
    },
    {
        path: ':token',
        component: PasswordResetComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PasswordResetRoutingModule {}
